import local from './local.json';
import global from './global.json';

export default {
  ...global,
  ...local,
};



// WEBPACK FOOTER //
// ./src/config/index.js